import images from './images';

const appetizers = [
  {
    title:'Appetizers Plate',
    price:'$15.95',
    tags:'Egg Roll, Crispy Won Ton, B.B.Q. Pork, Fried Prawns',
  },
  {
    title:'Crab Cheese Won Ton (8)',
    price:'$10.50',
    tags:'',
  },
  {
    title:'B.B.Q. Pork',
    price:'$11.95',
    tags:'',
  },
  {
    title:'Spring Roll (2)',
    price:'$3.95',
    tags:'',
  },
  {
    title:'Egg Roll',
    price:'$3.95',
    tags:'',
  },
  {
    title:'Golden Fried Won Tons (10)',
    price:'$6.95',
    tags:'',
  },
  {
    title:'Pot Stickers (8)',
    price:'$11.25',
    tags:'',
  },

];

const soups = [
  {
    title: 'Egg Flower Soup',
    price: 'Small $3.50 - Large $11.50',
    tags: '',
  },
  {
    title: 'Won Ton Soup',
    price: 'Small $3.75 - Large $11.75',
    tags: '',
  },
  {
    title: 'Hot & Sour Soup (Spicy)',
    price: 'Small $3.75 - Large $11.75',
    tags: '',
  },
  {
    title: 'Vegetable Soup',
    price: '$11.75',
    tags: '',
  },
];

const familyDinner = [
  {
    title: 'Canton Dinner',
    price: '$19.95 per order',
    tags: '**Two Order Minimum Required**',
    items: ['Soup of the Day', 'Egg roll', 'B.B.Q. Pork', 'Pork Lo Mein', 'Sweet & Sour Prawns', 'Almond Fried Chicken', 'Pork Fried Rice']
  },
  {
    title: 'Peking Dinner',
    price: '$19.95 per order',
    tags: '**Two Order Minimum Required**',
    items: ['Soup of the Day', 'Egg roll', 'B.B.Q. Pork', 'Chicken Chow Mein', 'Sweet & Sour Pork', 'Deep Fried Prawns', 'Pork Fried Rice']
  },
];

const combos = [
  {
    title: 'No. 1',
    price: '$15.50',
    items: ['Soup of the Day', 'Egg Foo Young', 'Pork Chow Mein','Sweet & Sour Chicken']
  },
  {
    title: 'No. 2',
    price: '$15.50',
    items: ['Soup of the day', 'Sweet & Sour Pork','Chicken Chow Mein', 'Pork Fried Rice']
  },
  {
    title: 'No. 3',
    price: '$16.50',
    items: ['Soup of the day','Fried Prawns', 'Egg Foo Young', 'Sweet & Sour Chicken', 'Pork Fried Rice']
  },
  {
    title: 'No. 4',
    price: '$16.50',
    items: ['Soup of the Day', 'Chicken Chow Mein','Sweet & Sour Prawns','B.B.Q. Pork','Pork Fried Rice']
  },
  {
    title: 'No. 5',
    price: '$16.95',
    items: ['Soup of the Day','Pork Chow Mein','Sweet & Sour Chicken','Egg Roll', 'Pork Fried Rice']
  },
  {
    title: 'No. 6',
    price: '$16.95',
    items: ['Soup of the day','Fried Prawns','Almond Fried Chicken','Sweet & Sour Pork','Pork Fried Rice']
  },
  {
    title: 'No. 7',
    price: '$17.95',
    items: ['Soup of the Day','B.B.Q. Pork','Fried Prawns','Sweet & Sour Chicken','Almond Pork Chow Mein','Pork Fried Rice']
  },
  {
    title: 'No. 8',
    price: '$17.95',
    items: ['Soup of the Day','Egg Roll','B.B.Q. Pork','Pork Chow Mein', 'Almond Fried Chicken','Pork Fried Rice']
  },
  {
    title: 'No. 9',
    price: '$16.95',
    items: ['Soup of the Day','Chicken Chow Mein','Sweet & Sour Spareribs','Almond Fried Chicken','Pork Fried Rice']
  },
  {
    title: 'No. 10',
    price: '$16.95',
    items: ['Soup of the Day','B.B.Q. Pork','Sweet & Sour Chicken','Almond Fried Chicken','Pork Lo Mein']
  },
];

const beef = [
  {
    title: 'Beef with Mixed Vegetables',
    price: '$15.50',
    tags: ''
  },
  {
    title: 'Mongolian Beef(Spicy)',
    price: '$15.50',
    tags: ''
  },
  {
    title: 'Beef with Broccoli',
    price: '$15.50',
    tags: ''
  },
  {
    title: 'Szechwan Beef(Spicy)',
    price: '$15.50',
    tags: ''
  },
  {
    title: ' Beef with Snow Pea',
    price: '$15.50',
    tags: ''
  },
  {
    title: ' Beef Cashew Nuts',
    price: '$15.50',
    tags: ''
  },
  {
    title: 'Kung Pao Beef',
    price: '$15.50',
    tags: ''
  },
];

const seafood = [
  {
    title: 'Deep Fried Prawns',
    price: '$16.50',
    tags: ''
  },
  {
    title: 'Sweet & Sour Prawns',
    price: '$16.50',
    tags: ''
  },
  {
    title: 'Shrimp with Cashew Nuts',
    price: '$16.50',
    tags: ''
  },
  {
    title: 'Kung Pao Shrimp(Spicy)',
    price: '$16.50',
    tags: ''
  },
  {
    title: 'Shrimp with Mixed Vegetables',
    price: '$16.50',
    tags: ''
  },
  {
    title: 'Shrimp with Snow Pea',
    price: '$16.50',
    tags: ''
  },
  {
    title: 'Princess Prawns(Spicy)',
    price: '$16.50',
    tags: ''
  },
  {
    title: 'Shrimp with Broccoli',
    price: '$16.50',
    tags: ''
  },
  {
    title: 'Thai Curry Shrimp(Spicy)',
    price: '$16.95',
    tags: ''
  },
];

const chicken = [
  {
    title: 'Teriyaki Chicken',
    price: '$15.50',
    tags: ''
  },
  {
    title: 'Kung Pao Chicken(Spicy)',
    price: '$15.50',
    tags: ''
  },
  {
    title: 'Chicken with Snow Pea',
    price: '$15.50',
    tags: ''
  },
  {
    title: 'Chicken with Cashew Nuts',
    price: '$15.50',
    tags: ''
  },
  {
    title: 'Sweet & Sour Chicken',
    price: '$15.50',
    tags: ''
  },
  {
    title: ' Boneless Almond Fried Chicken',
    price: '$15.50',
    tags: ''
  },
  {
    title: 'Mandarin Chicken(Spicy)',
    price: '$15.50',
    tags: ''
  },
  {
    title: 'Orange Chicken',
    price: '$15.50',
    tags: ''
  },
  {
    title: ' Chicken with Mixed Vegetables',
    price: '$15.50',
    tags: ''
  },
  {
    title: 'Thai Curry Chicken(Spicy)',
    price: '$15.50',
    tags: ''
  },
  {
    title: 'Chicken with Broccoli',
    price: '$15.50',
    tags: ''
  },
  {
    title: ' General Tso`s Chicken(Spicy)',
    price: '$15.50',
    tags: ''
  },
  {
    title: 'Mongolian Chicken(Spicy)',
    price: '$15.50',
    tags: ''
  },
];

const pork = [
  {
    title: 'Sweet & Sour Pork',
    price: '$15.50',
    tags: ''
  },
  {
    title: 'Pork with Mixed Vegetables',
    price: '$15.50',
    tags: ''
  },
  {
    title: 'B.B.Q. Pork with Snow Peas',
    price: '$15.50',
    tags: ''
  },
  {
    title: 'Happy Family',
    price: '$17.50',
    tags: '(Pork, Shrimp, Chicken, Beef Stir Fried with Mixed Vegetables)'
  },
  {
    title: 'Pork with Broccoli',
    price: '$15.50',
    tags: ''
  },
  {
    title: 'Kung Pao Pork(Spicy)',
    price: '$15.50',
    tags: ''
  },
];

const chowMein = [
  {
    title: 'Pork, Chicken, or Beef Chow Mein',
    price: '$14.75',
    tags: ''
  },
  {
    title: 'Vegetable Chow Mein',
    price: '$14.75',
    tags: ''
  },
  {
    title: 'Shrimp Chow Mein',
    price: '$15.75',
    tags: ''
  },
  {
    title: 'Almond Chicken Chow Mein',
    price: '$15.25',
    tags: ''
  },
  {
    title: 'Combination Chow Mein',
    price: '$17.95',
    tags: '(Pork, Chicken, Beef, and Shrimp. Over soft noodles)'
  },
];

const friedRice = [
  {
    title: 'Pork, Chicken, or Vegetable Fried Rice',
    price: '$14.50',
    tags: ''
  },
  {
    title: 'Beef Fried Rice',
    price: '$15.25',
    tags: ''
  },
  {
    title: 'Shrimp Fried Rice',
    price: '$15.50',
    tags: ''
  },
  {
    title: 'Combination Fried Rice',
    price: '$15.95',
    tags: '(Shrimp, Chicken, Pork, and Beef)'
  },
];

const noodleBowl = [
  {
    title: 'B.B.Q. Pork Noodle',
    price: '$14.50',
    tags: ''
  },
  {
    title: 'Chicken Noodle',
    price: '$14.50',
    tags: ''
  },
  {
    title: 'Beef with Vegetable Noodle',
    price: '$15.25',
    tags: ''
  },
  {
    title: 'House Noodle',
    price: '$15.95',
    tags: '(Shrimp, Chicken, B.B.Q. Pork, and Vegetable)'
  },
];

const phadThai = [
  {
    title: 'Chicken, Beef, or Pork',
    price: '$16.95',
    tags: ''
  },
  {
    title: 'Tofu or Vegetable',
    price: '$16.95',
    tags: ''
  },
  {
    title: 'Shrimp Phad Thai',
    price: '$17.95',
    tags: ''
  },
  {
    title: 'Combination Phad Thai',
    price: '$17.95',
    tags: '(Shrimp, Chicken, Pork, and Beef)'
  },
];

const pho = [
  {
    title: 'Beef or Chicken Pho',
    price: '$16.25',
    tags: ''
  },
  {
    title: 'Tofu or Vegetable Pho',
    price: '$16.25',
    tags: ''
  },
  {
    title: 'Shrimp or Meat Ball Pho',
    price: '$17.95',
    tags: ''
  },
  {
    title: 'Combination Pho',
    price: '$17.95',
    tags: '(Beef, Meat Ball, and Shrimp)'
  },
];

const eggFoo = [
  {
    title: 'Pork or Chicken',
    price: '$15.50',
    tags: ''
  },
];

const vegetarian = [
  {
    title: 'Assorted Vegetables',
    price: '$15.25',
    tags: ''
  },
  {
    title: 'Pea Pods with Chestnuts',
    price: '$15.25',
    tags: ''
  },
  {
    title: 'To Fu with Mix Vegetables',
    price: '$15.25',
    tags: ''
  },
  {
    title: 'To Fu Szechwan Style(Spicy)',
    price: '$15.25',
    tags: ''
  },
  {
    title: 'Broccoli Garlic Sauce',
    price: '$15.25',
    tags: ''
  },
  {
    title: 'Chef`s Spicy Vegetables',
    price: '$15.25',
    tags: ''
  },
  {
    title: 'Kung Pao To Fu(Spicy)',
    price: '$15.25',
    tags: ''
  },
];

const loMein = [
  {
    title: 'Vegetable Lo Mein',
    price: '$15.75',
    tags: ''
  },
  {
    title: 'Chicken Lo Mein',
    price: '$15.95',
    tags: ''
  },
  {
    title: 'Beef Lo Mein',
    price: '$15.95',
    tags: ''
  },
  {
    title: 'Pork Lo Mein',
    price: '$15.95',
    tags: ''
  },
  {
    title: 'Shrimp Lo Mein',
    price: '$16.95',
    tags: ''
  },
  {
    title: 'Combination Lo Mein',
    price: '$17.50',
    tags: '(Shrimp, Pork, Chicken and Beef)'
  },
];

const drinks = [
  {
    title: 'Soda',
    price: '$3.50',
    tags: 'Pepsi, Diet Pepsi, Mtn. Dew, 7-Up, Root Beer, Dr. Pepper' 
  },
  {
    title: 'Thai Ice Tea',
    price: '$5.95',
    tags: '' 
  },
  {
    title: 'Hot or Ice Tea',
    price: '$3.50',
    tags: '' 
  },
  {
    title: 'Coffee',
    price: '$3.50',
    tags: '' 
  },
  {
    title: 'Milk',
    price: '$3.50',
    tags: '' 
  },
  {
    title: 'Apple or Orange Juice',
    price: '$3.50',
    tags: '' 
  },
];



export default { appetizers, soups, familyDinner, combos, beef, seafood, chicken, pork, chowMein, friedRice, noodleBowl, phadThai, pho, eggFoo, vegetarian, loMein, drinks, };
